export function isWindow() {
    return typeof window !== 'undefined';
}
